<div class="transcript-container">
    <div class="modal-header">
        <h4 class="modal-title pull-left">Transcript</h4>
    </div>

    <div class="transcript-body">
        <div class="dialpad-transcript" *ngIf="isDialpad">
            <div *ngFor="let line of transcriptLines" class="dialpad-transcript-line">
                <strong class="dialpad-speaker">{{ line.speaker }}</strong>
                <span class="dialpad-text">{{ line.text }}</span>
            </div>
        </div>
        <div class="transcript" *ngIf="!isDialpad">
            <div *ngFor="let line of transcriptLines" class="transcript-line">
                <strong *ngIf="line.speaker">{{ line.speaker }}: </strong>
                <span>{{ line.text }}</span>
            </div>
        </div>
    </div>

    <div class="transcript-footer">
        <a class="transcript-cancel-text" (click)="closePanel()">
            <span id="transcript-cancel" translate>Close</span>
        </a>
    </div>
</div>